import { decodeUser, LoggedUser } from './session-decode';

const USER_INSTANCE_KEY = 'user_instance';

/** Usuário logado de sessionStorage['user_instance']; null se ausente ou ilegível. */
export function getLoggedUser(): LoggedUser | null {
  try {
    return decodeUser(sessionStorage.getItem(USER_INSTANCE_KEY));
  } catch {
    return null;
  }
}
